/** 本地导入支持的文件格式分组：上传限制、目录树文件图标共用同一口径 */
export const LOCAL_IMPORT_EXTENSION_GROUPS = Object.freeze({
  ppt: ['ppt', 'pptx'],
  word: ['docx'],
  markdown: ['md', 'markdown'],
  file: ['txt'],
  pdf: ['pdf'],
  html: ['html', 'htm'],
  image: ['jpg', 'jpeg', 'png', 'webp', 'bmp'],
  excel: ['xlsx', 'csv']
});

/** 本地导入 accept：只放开 .html，图标分组仍保留 htm */
export const LOCAL_IMPORT_ACCEPT = Object.entries(LOCAL_IMPORT_EXTENSION_GROUPS)
  .flatMap(([group, extensions]) => (group === 'html' ? ['html'] : extensions))
  .map((ext) => `.${ext}`)
  .join(',');

/** 资料库图片格式：HTML 替换图与目录树本地导入共用 */
export const LOCAL_IMPORT_IMAGE_ACCEPT = LOCAL_IMPORT_EXTENSION_GROUPS.image.map((ext) => `.${ext}`).join(',');

const BYTES_PER_KB = 1024;
/** 本地导入 / 替换图单文件最大体积，与目录树一致。 */
export const LOCAL_IMPORT_MAX_MB = 100;
export const LOCAL_IMPORT_MAX_SIZE = LOCAL_IMPORT_MAX_MB * BYTES_PER_KB * BYTES_PER_KB;
